import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAngleDown, faAngleUp, faBars, faGripVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BButtonGroup, BFormCheckbox } from "bootstrap-vue";
import { computed, ref } from "vue";
import { useUserStore } from "@/stores/userStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ListHeader',
    props: {
        listId: null,
        allSelected: { type: Boolean, default: false },
        showSelectAll: { type: Boolean, default: false },
        showViewToggle: { type: Boolean, default: false },
        showSortOptions: { type: Boolean, default: false },
        selectAllDisabled: { type: Boolean, default: false },
        indeterminateSelected: { type: Boolean, default: false }
    },
    emits: ["select-all"],
    setup(__props, { expose, emit }) {
        const props = __props;
        library.add(faAngleDown, faAngleUp, faBars, faGripVertical);
        const userStore = useUserStore();
        const sortDesc = ref(true);
        const sortBy = ref("update_time");
        const currentListViewMode = computed(() => userStore.currentListViewPreferences[props.listId] || "grid");
        function onSort(newSortBy) {
            if (sortBy.value === newSortBy) {
                sortDesc.value = !sortDesc.value;
            }
            else {
                sortBy.value = newSortBy;
            }
        }
        function onToggleView(newView) {
            userStore.setListViewPreference(props.listId, newView);
        }
        expose({
            sortBy,
            sortDesc,
        });
        return { __sfc: true, props, emit, userStore, sortDesc, sortBy, currentListViewMode, onSort, onToggleView, faAngleDown, faAngleUp, faBars, faGripVertical, FontAwesomeIcon, BButton, BButtonGroup, BFormCheckbox };
    }
});
